import React from 'react';
import { useLocation } from 'react-router-dom';
import LogoutButton from './LogoutButton';
import SidebarBankHeader from './components/SidebarBankHeader';
import Section from './components/Section';
import Item from './components/Item';
import { FiHome, FiBriefcase, FiUsers, FiClipboard, FiMapPin, FiFileText, FiPackage, FiVideo, FiRadio, FiShoppingCart, FiLink, FiUpload ,FiRefreshCw} from 'react-icons/fi';
import { Accordion } from './components/Accordion';
import { useAppSelector } from '../../store';
import { isPsoHeadDesignation } from '../../utils/psoDesignation';

export default function PsoSidebar() {
    const location = useLocation();
    const pso = useAppSelector((s) => s.user.pso);
    const isHead = isPsoHeadDesignation(pso?.designation);
    const isProtocolOfficer = pso?.designation?.toLowerCase().replace(/_/g, ' ') === 'protocol officer';
    const isInchargeHR = pso?.designation?.toLowerCase().replace(/_/g, ' ') === 'incharge hr';

    return (
        <div className="flex h-screen flex-col bg-white text-gray-900 dark:bg-[#0f172a] dark:text-white">
            <SidebarBankHeader title={isInchargeHR ? "HR Menu" : "PSO Menu"} />
            <nav className="flex-1 overflow-y-auto p-2 text-sm">
                <Accordion defaultOpenId={isInchargeHR ? "request" : (isProtocolOfficer ? "protocols" : "branches")}>
                    {isInchargeHR ? (
                        <Section id="request" title="Request" subtitle="Manage Request Forms" alwaysOpen>
                            <Item icon={FiFileText} label="Travelling Approval" to="/travelling-approval" active={location.pathname === '/travelling-approval'} />
                        </Section>
                    ) : isProtocolOfficer ? (
                        <Section id="protocols" title="Protocols" subtitle="Manage Protocol Operations">
                            <Item icon={FiClipboard} label="Protocols" to="/protocols" active={location.pathname === '/protocols'} />
                        </Section>
                    ) : (
                        <>
                            <Section id="main" title="Main Menu" alwaysOpen>
                                <Item icon={FiHome} label="Dashboard" to="/dashboard" active={location.pathname === '/dashboard'} />
                            </Section>
                            <Section id="branches" title="Branches" subtitle="Manage Branch Information">
                                <Item icon={FiBriefcase} label="View Branches" to="/branches" active={location.pathname === '/branches'} />
                                {isHead && (
                                    <>
                                        <Item
                                            icon={FiMapPin}
                                            label="Locations"
                                            to="/locations"
                                            active={location.pathname === '/locations'}
                                        />
                                        <Item
                                            icon={FiUsers}
                                            label="PSO"
                                            to="/pso"
                                            active={location.pathname === '/pso'}
                                        />
                                    </>
                                )}
                            </Section>
                            {(isHead || pso?.designation?.toLowerCase().replace(/_/g, ' ') === 'protocol officer') && (
                                <Section id="protocols" title="Protocols" subtitle="Manage Protocol Operations">
                                    <Item icon={FiClipboard} label="Protocols" to="/protocols" active={location.pathname === '/protocols'} />
                                </Section>
                            )}
                            {!isHead && (
                                <Section id="management" title="Vendor Management" subtitle="Manage Service Companies">
                                    <Item icon={FiUsers} label="Manage Vendors" to="/companies" active={location.pathname === '/companies'} />
                                    <Item icon={FiUpload} label="Deployment Vendor" to="/deployments" active={location.pathname === '/deployments'} />
                                </Section>
                            )}
                            <Section id="surveys" title="Survey Management" subtitle="Manage Survey Operations">
                                <Item icon={FiClipboard} label="Branch Surveys" to="/surveys" active={location.pathname === '/surveys'} />
                                <Item icon={FiMapPin} label="New Location Surveys" to="/new-location-surveys" active={location.pathname === '/new-location-surveys'} />
                                <Item icon={FiRefreshCw} label="Lease Renewal Surveys" to="/lease-renewal-surveys" active={location.pathname === '/lease-renewal-surveys'} />
                            </Section>
                            <Section id="request" title="Request" subtitle="Manage Request Forms">
                                {(isHead || pso?.designation?.toLowerCase().replace(/_/g, ' ').includes('regional')) && (
                                    <Item icon={FiClipboard} label="Request Summary" to="/request-summary" active={location.pathname === '/request-summary'} />
                                )}
                                <Item icon={FiFileText} label="Request Form" to="/request-form" active={location.pathname === '/request-form'} />
                                <Item icon={FiFileText} label="Travelling Approval" to="/travelling-approval" active={location.pathname === '/travelling-approval'} />
                                <Item icon={FiRefreshCw} label="Change of Vendor" to="/change-of-vendor" active={location.pathname === '/change-of-vendor'} />
                                <Item icon={FiUpload} label="Deployment Request" to="/deployment-request" active={location.pathname === '/deployment-request'} />
                                <Item icon={FiFileText} label="Weekly Report" to="/weekly-report" active={location.pathname === '/weekly-report'} />
                            </Section>
                            {!isHead && (
                                <Section id="manage-hardware" title="Hardware Management" subtitle="Track Hardware Installations and Shipments">
                                    <Item icon={FiVideo} label="CCTV Hardware" to="/manage-hardware-cctv" active={location.pathname === '/manage-hardware-cctv'} />
                                    <Item icon={FiRadio} label="BAMS Hardware" to="/manage-hardware-bams" active={location.pathname === '/manage-hardware-bams'} />
                                </Section>
                            )}
                            <Section id="hardware" title="Hardware Request" subtitle="Manage CCTV and BAMS Hardware Requests">
                                <Item icon={FiVideo} label="CCTV" to="/cctv" active={location.pathname === '/cctv'} />
                                <Item icon={FiRadio} label="BAMS" to="/bams" active={location.pathname === '/bams'} />
                            </Section>
                            {!isHead && (
                                <Section id="purchase-order" title="Purchase Order" subtitle="Manage Purchase Orders">
                                    <Item icon={FiShoppingCart} label="PO CCTV" to="/po-cctv" active={location.pathname === '/po-cctv'} />
                                    <Item icon={FiShoppingCart} label="PO BAMS" to="/po-bams" active={location.pathname === '/po-bams'} />
                                </Section>
                            )}
                        </>
                    )}
                </Accordion>
            </nav>
            <div className="shrink-0">
                <LogoutButton />
            </div>
        </div>
    );
}


